export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Top Section - 4 Column Grid */}
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1 - Logo & Description */}
          <div>
            <h3 className="text-2xl font-serif tracking-widest mb-4">プレミアム不動産</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              信頼と実績の<br />
              不動産エージェント<br />
              お客様の理想を実現します
            </p>
          </div>

          {/* Column 2 - Newsletter */}
          <div>
            <h4 className="text-sm font-light tracking-widest mb-6 text-gray-300">ニュースレター登録</h4>
            <div className="relative">
              <input
                type="email"
                placeholder="メールアドレス"
                className="w-full bg-transparent border-b border-gray-600 pb-3 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-colors text-sm"
              />
              <button className="absolute right-0 bottom-3 cursor-pointer" aria-label="送信">
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </button>
            </div>
            <p className="text-gray-500 text-xs mt-4">
              最新物件情報をお届けします
            </p>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h4 className="text-sm font-light tracking-widest mb-6 text-gray-300">サービス</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  売買仲介
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  賃貸仲介
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  物件管理
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Social */}
          <div>
            <h4 className="text-sm font-light tracking-widest mb-6 text-gray-300">フォロー</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Instagram
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Facebook
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  LINE
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Section - Large Brand Name */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-6 lg:px-12 py-12">
          
          {/* Copyright */}
          <div className="flex flex-col md:flex-row items-center justify-between text-gray-500 text-sm gap-4">
            <p>© 2024 Premium Estate. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">利用規約</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
